import React from 'react';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  return (
    <section className=" py-5" id='whychooseus'>
      <div className="container">
      <div className="row align-items-center gx-lg-5">
        
        {/* Left Image - Now visible on mobile too */}
        <div className="col-lg-6 mb-5 mb-lg-0">
          <div className="why-img-wrapper">
            <img 
              src="/choosebanner2.jpeg"
              alt="Gaubliiss A2 Cow Milk" 
              className="why-main-img" 
            />
            <div className="why-accent-box"></div>
          </div>
        </div>

        {/* Right Content */}
        <div className="col-lg-6">
          <div className="why-content-box">
            <h2 className="mb-3 whytitle">
              Why Choose <span className='gaubliisstext'>Gaubliiss</span> <br /> A2 Cow Milk?
            </h2>
            <div className="custom-divider mb-4"></div>
            
            <p className="why-desc-intro mb-4">
              <span className='gaubliisstext-small'>Gaubliiss</span> A2 Cow Milk is sourced from pure-bred Indian Gir cows, ensuring maximum health benefits for your family.
            </p>

            <ul className="why-list-custom">
              <li><span>✔</span> 100% A2 Protein Milk</li>
              <li><span>✔</span> Fresh & Delivered Daily</li>
              <li><span>✔</span> From Indigenous A2 Cows</li>
              <li><span>✔</span> No Hormones or Preservatives</li>
              <li><span>✔</span> Eco Friendly Glass Bottles</li>
              <li><span>✔</span> Better Digestion & Immunity</li>
            </ul>
          </div>
        </div>
        </div>
        
      </div>
    </section>
  );
};

export default WhyChooseUs;